import React, { useEffect } from 'react'; // eslint-disable-next-line
import { Row, Col, Card, CardBody, CardHeader, Button, Image, ProgressBar } from 'react-bootstrap'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api'; // eslint-disable-next-line
import config from '../../config'; // eslint-disable-next-line
import CopiriLoader from '../common/CopiriLoader';
import pollIcon from '../../assets/img/icons/poll-icon.jpeg';
import Footer from './Footer';
import no_gl_seal_light from '../../assets/img/logos/no_gl_seal_light.png';
const PollProjection = props => {
	const { pageLanguageContent, votingData } = props;
	useEffect(() => {
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<Row className='row g-0 mx-0'>
				{/* LEFT SIDE */}
				<Col md={6} className='pl-0'>
					<div className='voting-left d-flex flex-column justify-content-between p-4'>
						<div className='content'>
							<div className='logo-area mt-5'>
								<div className='seal'>
									<Image
										src={votingData.organization_icon ? votingData.organization_icon : no_gl_seal_light}
										alt={votingData?.organization_name}
									/>
								</div>
								<h4>{votingData?.organization_name}</h4>
							</div>
						</div>
						<Footer pageLanguageContent={pageLanguageContent} votingData={votingData} />
					</div>
				</Col>

				{/* RIGHT SIDE */}
				<Col md={6} className='right-panel'>
					{votingData && votingData.election_type && votingData.election_type.toLowerCase() === 'poll' && (
						<span className='poll-badge'>
							<Image className='me-2' src={pollIcon} alt={votingData?.contest_name} />
							{pageLanguageContent['VOT012'] ? pageLanguageContent['VOT012'] : ''}
						</span>
					)}
					<h2 className='question'>{votingData?.contest_name}</h2>
					{votingData?.candidates &&
						votingData?.candidates.length > 0 &&
						votingData?.candidates.map((item, i) => (
							<div className='option' key={i} id={'tr_' + item?.name}>
								<div className='option-top'>
									<span>{item?.name}</span>
									<span className='vote'>
										<span className='userSmallIcn'>
											<i className='fas fa-circle-user'></i>
										</span>{' '}
										{item?.votes}
									</span>
								</div>
								<ProgressBar now={item?.percent} />
							</div>
						))}
					{votingData && votingData.election_type && votingData.election_type.toLowerCase() === 'poll' && (
						<div className='turnout'>
							{votingData?.turnout_percent && (
								<>
									{pageLanguageContent['VOT015']
										? pageLanguageContent['VOT015'].replace('_total_', votingData?.turnout_percent)
										: ''}
								</>
							)}
						</div>
					)}
				</Col>
			</Row>
		</>
	);
};
export default PollProjection;
